<template>
  <BaseDialog
    title="Customer Location Update Details"
    v-model="customerLocationUpdateDialog"
    width="70%"
    :btnEnable="true"
  >
    <template #information>
      <v-row
        class="ma-0"
        v-if="
          customerLocationDetails &&
          Object.keys(customerLocationDetails).length > 0
        "
      >
        <v-col cols="12" md="12" class="pa-2">
          <v-row no-gutters>
            <v-col cols="12" md="4" lg="3">
              <span>Trip Reference Number :- &nbsp;</span>
              <span class="text-body-2 font-weight-bold">{{
                customerLocationDetails.trip_reference_number
              }}</span>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <span>Driver Name :- &nbsp;</span>
              <span class="text-body-2 font-weight-bold">
                {{ customerLocationDetails.driver_name }}
              </span>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <span>Status :- &nbsp;</span>
              <span class="text-body-2 font-weight-bold">{{
                !customerLocationDetails.is_approved &&
                !customerLocationDetails.is_rejected
                  ? "Pending"
                  : customerLocationDetails.is_approved &&
                    !customerLocationDetails.is_rejected
                  ? "Approved"
                  : "Rejected"
              }}</span>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <span>Location ID :- &nbsp;</span>
              <span class="text-body-2 font-weight-bold">{{
                customerLocationDetails.location_id
              }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="pa-2">
          <v-card>
            <v-card-title>
              <span>Previous Information </span>
            </v-card-title>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="3" class="py-2"> Address :- &nbsp; </v-col>
                <v-col cols="9" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.previous_address
                  }}</span>
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  From Time :- &nbsp;
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.previous_from_time
                  }}</span>
                </v-col>
                <v-col cols="6" md="3" class="py-2"> To Time :- &nbsp; </v-col>
                <v-col cols="6" md="3" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.previous_to_time
                  }}</span>
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  Contact Person :- &nbsp;
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.previous_contact_person
                  }}</span>
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  Contact Number :- &nbsp;
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.previous_contact_number
                  }}</span>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-subtitle class="pa-0">
              <GoogleMap
                mapId="locationMap1"
                mapWidth="100%"
                mapHeight="calc(100vh - 500px)"
                ref="locationMap1"
                :isDrawable="false"
                :hasMapInfo="false"
              />
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" class="pa-2">
          <v-card>
            <v-card-title>
              <span>Updated Information </span>
            </v-card-title>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="3" class="py-2"> Address :- &nbsp; </v-col>
                <v-col cols="9" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.updated_address
                  }}</span>
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  From Time :- &nbsp;
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.updated_from_time
                  }}</span>
                </v-col>
                <v-col cols="6" md="3" class="py-2"> To Time :- &nbsp; </v-col>
                <v-col cols="6" md="3" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.updated_to_time
                  }}</span>
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  Contact Person :- &nbsp;
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.updated_contact_person
                  }}</span>
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  Contact Number :- &nbsp;
                </v-col>
                <v-col cols="6" md="3" class="py-2">
                  <span class="text-body-2 font-weight-bold">{{
                    customerLocationDetails.updated_contact_number
                  }}</span>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-subtitle class="pa-0">
              <GoogleMap
                mapId="locationMap2"
                mapWidth="100%"
                mapHeight="calc(100vh - 500px)"
                ref="locationMap2"
                :isDrawable="false"
                :hasMapInfo="false"
              />
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template #action>
      <ErrorButton
        icon="mdi-close"
        v-if="
          customerLocationDetails &&
          !customerLocationDetails.is_approved &&
          !customerLocationDetails.is_rejected
        "
        name="Reject"
        @click="$emit('reject', customerLocationId)"
      />
      <SuccessButton
        icon="mdi-check"
        v-if="
          customerLocationDetails &&
          !customerLocationDetails.is_approved &&
          !customerLocationDetails.is_rejected
        "
        name="Approve"
        @click="$emit('approve', customerLocationId)"
      />
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import { bus } from "@/main";

export default {
  components: { BaseDialog, GoogleMap },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    customerLocationId: { type: Number },
  },
  computed: {
    customerLocationUpdateDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      customerLocationDetails: null,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.viewCustomerLocationUpdateDetails(this.customerLocationId);
      }
    },
  },
  methods: {
    viewCustomerLocationUpdateDetails(id) {
      bus.$emit("showLoader", true);
      this.$api.customerLocationUpdate
        .getCustomerLocationUpdateObject(id)
        .then((res) => {
          this.customerLocationDetails = res.data;
          this.loadLocationsOnMap();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "Something went wrong!",
            color: "error",
          });
        });
    },
    loadLocationsOnMap() {
      let inter = setInterval(() => {
        if (
          this.$refs.locationMap1 &&
          this.$refs.locationMap2 &&
          window.google
        ) {
          clearInterval(inter);
          this.$refs.locationMap1.removeAllMarkers();
          this.$refs.locationMap2.removeAllMarkers();
          if (
            this.customerLocationDetails.previous_coordinates &&
            this.customerLocationDetails.previous_coordinates.coordinates
          ) {
            this.$refs.locationMap1.addMarker(
              this.customerLocationDetails.previous_coordinates
            );
          }
          if (
            this.customerLocationDetails.updated_coordinates &&
            this.customerLocationDetails.updated_coordinates.coordinates
          ) {
            this.$refs.locationMap2.addMarker(
              this.customerLocationDetails.updated_coordinates
            );
          }
        }
      }, 200);
    },
  },
};
</script>

<style></style>
